import { Badge } from "../../components/Table";
import Edit from "./../../components/buttons/Edit";

export const technicianTableHeadData = [
  {
    accessorKey: "no",
    header: "Sl No",
    size: 100,
  },
  {
    accessorKey: "uid",
    header: "UID",
    size: 100,
  },
  {
    accessorKey: "firstName",
    header: "First Name",
    size: 150,
  },
  {
    accessorKey: "lastName",
    header: "Last Name",
    size: 150,
  },
  {
    accessorKey: "email",
    header: "Eamil",
    size: 250,
  },
  {
    accessorKey: "phone",
    header: "Phone",
    size: 150,
  },
  // {
  //   accessorKey: "status",
  //   header: "Status",
  //   size: 150,
  // },
  {
    accessorKey: "action",
    header: "Action",
    size: 150,
  },
];

export const getTechnicianTableData = (dataSet) => {
  const tableData = dataSet?.map((item, idx) => {
    return {
      no: idx + 1,
      uid: item?.uid,
      firstName: item?.first_name || "N/A",
      lastName: item?.last_name || "N/A",
      email: item?.email || "N/A",
      phone: item?.mobile_number || "N/A",
      status: <Badge status={item?.status} />,
      action: <Edit user={item} />,
    };
  });
  return tableData;
};
